import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { Row, Col, Button, Form, Table } from "react-bootstrap";
import { OrderConfirmationStatus } from "./store/constants";
import Loading from "../../components/Loading/Loading";
import {
  parse,
  isValid,
  addDays,
  isWeekend,
  format,
  startOfDay,
} from "date-fns";
import { Link } from "react-router-dom";
import { setErrorStatus } from "../organisations/store/action-creators";
import { sortBy, some, find } from "lodash";
import "react-dates/initialize";
import { SingleDatePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import(/* webpackChunkName: "repairCheckout" */ "./repairCheckout.scss");

const RepairCheckout = ({
  submitRepairOrder,
  orderConfirmationStatus,
  orderConfirmationData,
  sentOrderConfirmationStatus,
  orderNumber,
  cartData,
  addOrderToCart,
  loadOrderConfirmation,
  resetOrderNumber,
  profileData,
}) => {
  const [orderShippingRate, setOrderShippingRate] = useState("standard");
  const [selectedSite, setSelectedSite] = useState(0);
  const [requiredByDate, setRequiredByDate] = useState();
  const [siteError, setSiteError] = useState();
  const [siteList, setSiteList] = useState([]);
  const [isHAFSorderChecked, setIsHAFSorderChecked] = useState(false);
  const [isVAClientChecked, setIsVAClientChecked] = useState(false);
  const [hideVACheckbox, setHideVACheckbox] = useState(false);
  const [isTritonStore, setIsTritonStore] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [requiredByDateFocused, setRequiredByDateFocused] = useState(false);
  const [files, setFiles] = useState([]);

  const [repairStandardDays, setRepairStandardDays] = useState(0);
  const [repairCustomDays, setRepairCustomDays] = useState(0);
  const [remakeCustomDays, setRemakeCustomDays] = useState(0);

  let history = useHistory();
  const location = useLocation();
  useEffect(() => {
    setHideVACheckbox(false);
    setIsTritonStore(false);
    if (profileData) {
      if (profileData.IsSpecsavers) {
        setHideVACheckbox(true);
      }
      if (profileData.IsTriton) {
        setIsTritonStore(true);
      }
    }
  }, [profileData]);

  useEffect(() => {
    const { repairRemakeFormObject } = location.state || {};
    // console.log("repairRemakeFormObject", repairRemakeFormObject)

    if (!repairRemakeFormObject) {
      history.push({ pathname: "/store/Repair/Repair" });
    }
    // setRepairRemakeFormObject(repairRemakeFormObject)
  }, []);

  useEffect(() => {
    setHideVACheckbox(false);

    if (profileData) {
      // console.log("profileData - ", profileData);
      if (profileData.IsSpecsavers) {
        setHideVACheckbox(true);
      }
    }
  }, [profileData]);

  const handleHAFSorderChange = (event) => {
    setIsHAFSorderChecked(event.target.checked);
  };

  const handleVAClientChange = (event) => {
    setIsVAClientChecked(event.target.checked);
  };

  const handleSiteChange = (event) => {
    const myValue = event.target.value;
    setSelectedSite(myValue);
  };

  const addWorkingDays = (startDate, numberOfDays) => {
    let currentDate = startDate;
    let addedDays = 0;

    while (addedDays < numberOfDays) {
      currentDate = addDays(currentDate, 1);
      if (!isWeekend(currentDate)) {
        addedDays++;
      }
    }

    return currentDate;
  };

  const isWeekday = (date) => {
    return !isWeekend(date.toDate());
  };

  useEffect(() => {
    const today = startOfDay(new Date());
    let minimumDaysRequired = 1; // Default minimum days

    const { repairRemakeFormObject } = location.state || {};
    if (orderConfirmationData && repairRemakeFormObject) {
      let repairStandard = orderConfirmationData.find((timeline) => {
        return timeline.Code === "Repair";
      });
      let remakeCustom = orderConfirmationData.find((timeline) => {
        return timeline.Code === "RemoteRicReceiverReplacement";
      });
      let repairCustom = orderConfirmationData.find((timeline) => {
        return timeline.Code === "ReshellRemake";
      });

      setRepairStandardDays(
        repairStandard ? repairStandard.MinimumDaysRequired : 3,
      );
      setRepairCustomDays(
        remakeCustom ? remakeCustom.MinimumDaysRequired : 5,
      );
      setRemakeCustomDays(
        repairCustom ? repairCustom.MinimumDaysRequired : 8,
      );
      if (repairRemakeFormObject.OrderType === "Repair") {
        minimumDaysRequired = repairStandard
          ? repairStandard.MinimumDaysRequired
          : 1;
      } else if (
        repairRemakeFormObject.OrderType === "RemoteRicReceiverReplacement"
      ) {
        minimumDaysRequired = remakeCustom
          ? remakeCustom.MinimumDaysRequired
          : 1;
      } else if (repairRemakeFormObject.OrderType === "ReshellRemake") {
        minimumDaysRequired = repairCustom
          ? repairCustom.MinimumDaysRequired
          : 1;
      }
    } else {
      setRepairStandardDays(3);
      setRepairCustomDays(5);
      setRemakeCustomDays(8);
    }

    const minimumDate = addWorkingDays(today, minimumDaysRequired);
    setMinDate(format(minimumDate, "yyyy-MM-dd"));
  }, [cartData, orderConfirmationData]);

  useEffect(() => {
    if (loadOrderConfirmation) {
      loadOrderConfirmation();
    }
  }, [loadOrderConfirmation]);

  useEffect(() => {
    if (profileData) {
      // console.log("profileData - ", profileData.Sites);
      let tempSiteList = sortBy(profileData.Sites, [
        function (site) {
          return site.SiteName;
        },
      ]);
      setSiteList(tempSiteList);
    }
  }, [profileData]);

  const handleSubmit = (event) => {
    event.preventDefault();

    // Gets values from the form and sets to local variables
    const {
      purchaseOrderNumber,
      specialInstructions,
      firstName,
      lastName,
      HAFSorder,
      childHAFSRepair,
      VAClient,
    } = document.forms[0];

    let tempSite = "";

    if (siteList.length == 1) {
      tempSite = siteList[0].SiteCode;
    } else {
      setSiteError();
      const { site } = document.forms[0];
      if (site.value) {
        tempSite = siteList[site.value].SiteCode;
      } else {
        setSiteError("Please select a site");
        return;
      }
    }

    // Send order to API ./store/saga
    const { repairRemakeFormObject } = location.state || {};

    let tempRequiredByDate = "";
    if (requiredByDate) {
      tempRequiredByDate = requiredByDate.format("YYYY-MM-DD");
    }

    //check if the childHAFSRepair checkbox exists
    let childHAFSRepairValue = false;
    if (childHAFSRepair?.checked) {
      childHAFSRepairValue = childHAFSRepair.checked;
    }

    submitRepairOrder(
      // repairRemakeFormObject.Model,
      repairRemakeFormObject,
      orderShippingRate,
      purchaseOrderNumber.value,
      profileData.OrganisationCode,
      tempSite,
      firstName.value,
      lastName.value,
      tempRequiredByDate,
      false, // isHAFSorderChecked REMOVED but keeping value here call to saga file
      childHAFSRepairValue,
      false, // isVAClientChecked REMOVED but keeping value here call to saga file
      // repairRemakeFormObject,
      // repairRemakeFormObject.ModelCode,
      repairRemakeFormObject.RightModel,
      repairRemakeFormObject.RightModelCode,
      repairRemakeFormObject.LeftModel,
      repairRemakeFormObject.LeftModelCode,
      repairRemakeFormObject.LeftEarImpression,
      repairRemakeFormObject.RightEarImpression,
      files,
    );
  };

  const goToSuccessScreen = () => {
    if (
      sentOrderConfirmationStatus === OrderConfirmationStatus.SUCCESS &&
      orderNumber
    ) {
      //Clear cart
      addOrderToCart();
      loadOrderConfirmation();
      resetOrderNumber();
      let url = `/profile/order-history/${orderNumber}`;
      history.push({ pathname: `${url}` });
      // history.push({ pathname: "/order-confirmation/success" });
    }
  };

  const parseDate = (input) => {
    // Try different date formats here based on your requirements
    const formats = [
      "yyyy-MM-dd",
      "yyyyMMdd",
      "yyyy/MM/dd",
      "yyyy.MM.dd",
      "MM/dd/yyyy",
      "MMddyyyy",
      "MM-dd-yyyy",
      "MM.dd.yyyy",
      "dd/MM/yyyy",
      "ddMMyyyy",
      "dd-MM-yyyy",
      "dd.MM.yyyy",
      "yyyy/MM/dd",
      "yyyy-MM-dd",
      "yyyy.MM.dd",
      "dd/MM/yyyy",
      "dd-MM-yyyy",
      "dd.MM.yyyy",
      "yyyy-MM-dd'T'HH:mm:ss.SSSXXX",
      "yyyy-MM-dd'T'HH:mm:ss",
      "yyyy-MM-dd HH:mm:ss",
      "MMMM d, yyyy",
      "d MMMM yyyy",
    ];
    for (let f of formats) {
      const parsed = parse(input, f, new Date());
      if (isValid(parsed)) {
        // console.log("parsed", parsed)
        // console.log("format(parsed, 'dd-MM-yyyy')", format(parsed, 'dd-MM-yyyy'))

        return parsed;
      }
    }
    return null;
  };

  const handleDateOfBirthPaste = (e) => {
    const pastedText = e.clipboardData.getData("text");
    //console.log(pastedText);
    const parsedDate = parseDate(pastedText);
    if (parsedDate) {
      e.preventDefault();
      setDateOfBirth(format(parsedDate, "yyyy-MM-dd"));
    }
  };
  const handleRequiredByDatePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const parsedDate = parseDate(pastedText);
    const formatedDate = format(parsedDate, "yyyy-MM-dd");

    // console.log("formatedDate", formatedDate)
    // console.log("minDate", minDate)

    if (parsedDate && !isWeekend(formatedDate) && formatedDate >= minDate) {
      //minDate check parsedDate is > minDate
      // console.log("moment(formatedDate)", moment(formatedDate))

      setRequiredByDate(moment(formatedDate));
    } else {
      alert("Pasted date is invalid or falls on a weekend.");
    }
  };

  const handleRequiredByDateChange = (newDate) => {
    // console.log("newDate", newDate)
    if (newDate && !isWeekend(newDate.toDate())) {
      setRequiredByDate(newDate);
    }
  };

  const handleFileChange = (event) => {
    let incorrectFileTypesUploaded = false;
    const selectedFiles = Array.from(event.target.files);

    const filteredFiles = selectedFiles.filter((file) => {
      // ['.pdf', '.png', '.jpeg', '.jpg'].includes(file.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0])
      if (
        ![".pdf", ".png", ".jpeg", ".jpg", ".stl", ".asc"].includes(
          file.name.toLowerCase().match(/\.[0-9a-z]+$/i)[0],
        )
      ) {
        incorrectFileTypesUploaded = true;
        return false;
      } else {
        return true;
      }
    });

    if (incorrectFileTypesUploaded) {
      alert("INCORRECT FILE TYPES");
    }

    if (filteredFiles.length + files.length > 3) {
      alert("You can only upload up to 3 files.");
      return;
    }

    const invalidChars = /[<>:"/\\|?*#\x00-\x1F]/g;
    const sanitizedFiles = filteredFiles.map((file) => {
      const sanitizedFileName = file.name.replace(invalidChars, "");

      return new File([file], sanitizedFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
    });

    // setFiles([...files, ...filteredFiles]);
    setFiles([...files, ...sanitizedFiles]);
  };

  const removeFile = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  //If API returns a success show a success screen
  useEffect(() => {
    goToSuccessScreen();
  }, [sentOrderConfirmationStatus, orderNumber]);

  if (sentOrderConfirmationStatus === OrderConfirmationStatus.LOADING) {
    return (
      <Col>
        <div className="">
          <Loading />
        </div>
      </Col>
    );
  }

  return (
    <div className="order-confirmation-main-div">
      <div className="order-confirmation-title">
        <h1>Repair / Remake Checkout</h1>
        <p>
          Please check the following information is correct and fill out the
          available fields if applicable.
        </p>
      </div>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="order-confirmation-sub-heading">
            <h2>Processing Information</h2>
          </Col>
          <Col xs={5}>
            <table className="table-full-width">
              {profileData && profileData.FirstName && profileData.LastName && (
                <tr>
                  <th>Name</th>
                  <td>
                    {profileData.FirstName} {profileData.LastName}
                  </td>
                </tr>
              )}
              {profileData && profileData.OrganisationCode && (
                <tr>
                  <th>Organisation</th>
                  <td>{profileData.OrganisationName}</td>
                </tr>
              )}
              {siteList && siteList.length == 1 && (
                <tr>
                  <th>Site</th>
                  <td>{siteList[0] && siteList[0].SiteName}</td>
                </tr>
              )}
              <tr>
                <th>Client First Name *</th>
                <td>
                  <Form.Control
                    type="text"
                    name="firstName"
                    className="me-2"
                    aria-label="firstName"
                    required
                  />
                </td>
              </tr>
              <tr>
                <th>Client Last Name *</th>
                <td>
                  <Form.Control
                    type="text"
                    name="lastName"
                    className="me-2"
                    aria-label="lastName"
                    required
                  />
                </td>
              </tr>
              <tr>
                <th>Required By </th>
                <td>
                  <div>
                    <div
                      // style={{ opacity: 0, height: 0, position: 'absolute', zIndex: -1 }}
                      onPaste={handleRequiredByDatePaste}
                    >
                      <SingleDatePicker
                        date={requiredByDate}
                        onDateChange={handleRequiredByDateChange}
                        focused={requiredByDateFocused}
                        onFocusChange={({ focused }) =>
                          setRequiredByDateFocused(focused)
                        }
                        id="requiredByDate"
                        isDayBlocked={(day) => isWeekend(day.toDate())}
                        numberOfMonths={1}
                        isOutsideRange={(day) => day.isBefore(minDate)}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>Purchase Order #</th>
                <td>
                  <Form.Control
                    type="text"
                    name="purchaseOrderNumber"
                    className="me-2"
                    aria-label="purchaseOrderNumber"
                    required={isHAFSorderChecked || isVAClientChecked}
                  />
                </td>
              </tr>
              {/* <tr>
                <th>HAFS <br /><span className="hafs-title">{"("}Hearing Aid Funding Scheme{")"}</span></th>
                <td>
                  <Form.Control
                    type="checkbox"
                    name="HAFSorder"
                    className="me-2 hafs-checkbox"
                    aria-label="HAFSorder"
                    onChange={handleHAFSorderChange}
                  />
                </td>
              </tr> */}
              {!hideVACheckbox && !isTritonStore && (
                <tr>
                  <th>
                    Ko Taku Reo
                    <br />
                    <span className="hafs-title">
                      {"("}Child HAFS Repair{")"}
                    </span>
                  </th>
                  <td>
                    <Form.Control
                      type="checkbox"
                      name="childHAFSRepair"
                      className="me-2 hafs-checkbox"
                      aria-label="childHAFSRepair"
                    />
                  </td>
                </tr>
              )}
              <tr>
                <th>
                  File Upload
                  <br />
                  <span className="hafs-title">
                    Please select up to 3 files. The files will be uploaded when
                    you submit your order.
                  </span>
                </th>
                <td className="file-upload-td">
                  <div class="fileUpload">
                    <input
                      type="file"
                      id="file-input"
                      className="file-input__input"
                      onChange={handleFileChange}
                      multiple
                      accept=".pdf,.png,.jpeg,.jpg,.stl,.asc"
                    />
                    <label className="file-input__label" for="file-input">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="upload"
                        className="svg-inline--fa fa-upload fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
                        ></path>
                      </svg>
                      <span>Select File(s)</span>
                    </label>
                  </div>
                  {/* <button onClick={handleUpload} disabled={files.length === 0}>Upload Files</button> */}
                  <ul>
                    {files.map((file, index) => (
                      <li key={index}>
                        {file.name}{" "}
                        <Button
                          variant="danger ml-2"
                          onClick={() => removeFile(index)}
                        >
                          Remove
                        </Button>
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
              {/* {!hideVACheckbox &&
                <tr>
                  <th>Veteran's Affairs {"("}VA{")"} Client<br /><span className="hafs-title">{"("}Please select when ordering specific product from VA price list, pricing PO number{")"}</span></th>
                  <td>
                    <Form.Control
                      type="checkbox"
                      name="VAClient"
                      className="me-2 hafs-checkbox"
                      aria-label="VAClient"
                      onChange={handleVAClientChange}
                    />
                  </td>
                </tr>
              } */}
            </table>
          </Col>
          {!hideVACheckbox && (
            <Col
              xs={12}
              md={{ span: 5, offset: 1 }}
              className="repair-category"
            >
              <table className="table-full-width repair-category-table">
                <tr>
                  <th>Category</th>
                  <th>
                    Routine in-house turn-around time*
                    <br />
                    (working days)
                  </th>
                </tr>
                <tr>
                  <td>Repair - Standard Product</td>
                  <td>{repairStandardDays}</td>
                </tr>
                <tr>
                  <td>Repair - Custom Product</td>
                  <td>{repairCustomDays}</td>
                </tr>
                <tr>
                  <td>Remake - Custom Product</td>
                  <td>{remakeCustomDays}</td>
                </tr>
              </table>
              <p className="subtext">
                *In-house TAT reflect working days in house from arrival to
                dispatch, are intended to provide a general guidance, and may
                vary depending on incoming volume &/or staffing. We are unable
                to guarantee inbound/outbound courier turn-times.
              </p>
            </Col>
          )}
          <Col xs={12}>
            {siteList && siteList.length > 1 && (
              <table className="shipping-options-top-input">
                <tr>
                  <th>SITE:</th>
                  {siteList.map((site, index) => {
                    return (
                      <td key={index}>
                        <input
                          onChange={handleSiteChange}
                          id={`site-${index}`}
                          type="radio"
                          value={index}
                          checked={selectedSite == index}
                          name="site"
                        />
                        {site.SiteName}
                      </td>
                    );
                  })}
                </tr>
              </table>
            )}
            {siteError && (
              <div className="alert alert-danger">
                <p>{siteError}</p>
              </div>
            )}
          </Col>
        </Row>

        <Row>
          {sentOrderConfirmationStatus === OrderConfirmationStatus.ERROR && (
            <Col xs={12}>
              <div className="alert alert-danger">
                <p>
                  An error occured with submitting your order. Please try again
                </p>
              </div>
            </Col>
          )}
          <Col xs={2} className="offset-10">
            <Button type="submit" className="btn btn-primary float-right">
              Submit Order
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

RepairCheckout.propTypes = {
  submitRepairOrder: PropTypes.func,
  orderConfirmationStatus: PropTypes.string,
  sentOrderConfirmationStatus: PropTypes.string,
  orderNumber: PropTypes.string,
  cartData: PropTypes.array,
  addOrderToCart: PropTypes.func,
  loadOrderConfirmation: PropTypes.func,
  resetOrderNumber: PropTypes.func,
  profileData: PropTypes.object,
};

export default RepairCheckout;
